import { gql } from '@apollo/client';

export const RESTORE_TAG_GROUP = gql`
  mutation restoreTagGroup($id: Int!) {
    restoreTagGroup(id: $id) {
      success
      error
    }
  }
`;
